import { RAMQCurrentUser } from "@/Common/Models/RAMQ/RAMQCurrentUser";
import { RAMQDoctor } from "@/Common/Models/RAMQ/RAMQDoctor";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { CertThumbprint } from "@/Settings/Api/Dto/Response/CertThumbprint";
import { SettingsStore } from "@/Settings/Stores/SettingsStore";

class SettingsUIHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.SettingsUI.ShowPwdChange, this.ShowPwdChangeUI);
        this.RegisterOperation(LocalOperations.SettingsUI.HidePwdChange, this.HidePwdChangeUI);
        this.RegisterOperation(LocalOperations.SettingsUI.ShowPINChange, this.ShowPINChange);
        this.RegisterOperation(LocalOperations.SettingsUI.HidePINChange, this.HidePINChange);
        this.RegisterOperation(LocalOperations.SettingsUI.ShowUrlEditControl, this.ShowUrlEditControl);
        this.RegisterOperation(LocalOperations.SettingsUI.HideUrlEditControl, this.HideUrlEditControl);
        this.RegisterOperation(LocalOperations.SettingsUI.AutoRespondersControlShowHide, this.AutoRespondersControlShowHide);
        this.RegisterOperation(LocalOperations.SettingsUI.AutoRespondersControlShow, this.AutoRespondersControlShow);
        this.RegisterOperation(LocalOperations.SettingsUI.ToggleEnrollmentSummary, this.ToggleEnrollmentSummary);
        this.RegisterOperation(LocalOperations.SettingsUI.ExportEnrollmentCSV, this.ExportEnrollmentCSV);
        this.RegisterOperation(LocalOperations.SettingsUI.CloseLocateDSQKeysPopup, this.CloseLocateDSQKeysPopup);
        this.RegisterOperation(LocalOperations.SettingsUI.SelectDSQKey, this.SelectDSQKey);
    }

    private CloseLocateDSQKeysPopup(): void {
        settingsStore.uiLogic = settingsStore.uiLogic.set("DisplayLocatedDSQCertificates", false);
    }

    private SelectDSQKey(request: LocalEvent): void {
        const cert = request.Get<CertThumbprint>("item");
        settingsStore.action.Execute(ServerOperations.Server.Configuration_UpdateEmployeeThumbprintDSQ, { ThumbPrintDSQ: cert.Thumbprint }, null);
    }

    private ExportEnrollmentCSV(request: LocalEvent, store: SettingsStore): void {
        const ramqCurrentUser = new RAMQCurrentUser();
        ramqCurrentUser.AIPu = sessionStore.getCurrentEmployee().getActiveSite().Model.AipLogin;
        ramqCurrentUser.CElogin = sessionStore.getCurrentEmployee().Model.CeLoginRamq;

        const ramqDoctor = new RAMQDoctor();
        ramqDoctor.Class = "1";
        ramqDoctor.NoGMF = cacheStore.GetSiteById(sessionStore.getCurrentEmployee().getActiveSite().Model.ParentSiteId).Model.ClinicalCode;
        ramqDoctor.Licence = sessionStore.getCurrentEmployee().Model.FirstLicenceNumber;

        const url = apiSettings.buildAppUrl(
            "api/ramq/enrollment/getPatientRegistrations.csv",
            {
                auth: true,
                params: {
                    RAMQDoctor: JSON.stringify(ramqDoctor),
                    RamqCUrrentUser: JSON.stringify(ramqCurrentUser)
                }
            }
        );
        window.open(url, "_blank");

        store.uiLogic = store.uiLogic.set("DisplayEnrollmentSummary", false);
    }

    private ToggleEnrollmentSummary(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("DisplayEnrollmentSummary", !store.uiLogic.get("DisplayEnrollmentSummary"));

        if (store.uiLogic.get("DisplayEnrollmentSummary"))
            store.action.LoadPatientEnrollments();
    }

    private ShowPwdChangeUI(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("ShowPwdChange", true);
    }

    private HidePwdChangeUI(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("ShowPwdChange", false);
    }

    private ShowPINChange(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("ShowPINChange", true);
    }

    private HidePINChange(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("ShowPINChange", false);
    }

    private ShowUrlEditControl(request: LocalEvent, store: SettingsStore): void {
        store.uiLogic = store.uiLogic.set("ShowUrlEdit", true);
    }

    private HideUrlEditControl(request: LocalEvent, store: SettingsStore): void {
        const url = request.Get<string>("url");
        store.configuration = store.configuration.set("UsefulUrl", url);
        store.uiLogic = store.uiLogic.set("ShowUrlEdit", false);
    }

    private AutoRespondersControlShowHide(request: LocalEvent, store: SettingsStore): void {
        const val = request.Get<KeyValuePair<string, string>>("value");
        const isActive = val.Value === "t";
        store.configuration = store.configuration.set("IsAutoResponseActive", isActive);
        store.uiLogic = store.uiLogic.set("ShowAutoResponderForm", isActive);
    }

    private AutoRespondersControlShow(request: LocalEvent, store: SettingsStore): void {
        store.configuration = store.configuration.set("IsAutoResponseActive", true);
        store.uiLogic = store.uiLogic.set("ShowAutoResponderForm", true);
    }
}

export { SettingsUIHandler };
